import {
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  UPDATE_PROFILE_INVALID_REQUEST,
  UPDATE_PROFILE_INVALID_NAME,
  UPDATE_PROFILE_INVALID_STATE,
  UPDATE_PROFILE_INVALID_ZIP,
  UPDATE_PROFILE_INVALID_CITY,
  UPDATE_PROFILE_INVALID_COUNTRY,
  UPDATE_PROFILE_INVALID_GENDER,
  UPDATE_PROFILE_INVALID_ADDRESS,
  RESET_PROFILE,
  LOADING_PROFILE
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  invalidName: false,
  invalidGender: false,
  invalidCountry: false,
  invalidAddress: false,
  invalidCity: false,
  invalidState: false,
  invalidZip: false,
  success: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PROFILE:
      return {
        ...state,
        isLoading: true,
        success: false,
        invalidRequest: false,
        failed: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: {}
      };
    case UPDATE_PROFILE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };
    case UPDATE_PROFILE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload.data
      };

    case UPDATE_PROFILE_INVALID_NAME:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: true,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_GENDER:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: true,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_COUNTRY:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: true,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_ADDRESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: true,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_CITY:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: true,
        invalidState: false,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_STATE:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: true,
        invalidZip: false,
        data: action.payload
      };

    case UPDATE_PROFILE_INVALID_ZIP:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidName: false,
        invalidGender: false,
        invalidCountry: false,
        invalidAddress: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: true,
        data: action.payload
      };

    case RESET_PROFILE:
      return (state = initialState);

    default:
      return state;
  }
};
